import { render } from "./ShowBarometer.vue?vue&type=template&id=4fb7db38&scoped=true"
import script from "./ShowBarometer.vue?vue&type=script&lang=js"
export * from "./ShowBarometer.vue?vue&type=script&lang=js"

import "./ShowBarometer.vue?vue&type=style&index=0&id=4fb7db38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb7db38"]])

export default __exports__